/* tslint:disable */
/* eslint-disable */
/**
 * MINDD SCAN2 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ScanEegQualityTransmissionStatus } from '../model';
/**
 * EegQualityControllerApi - axios parameter creator
 * @export
 */
export const EegQualityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSqiStatus: async (deviceSerial: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('getSqiStatus', 'deviceSerial', deviceSerial)
            const localVarPath = `/eeg-quality/{deviceSerial}/status`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSqi: async (deviceSerial: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('startSqi', 'deviceSerial', deviceSerial)
            const localVarPath = `/eeg-quality/{deviceSerial}/start`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopSqi: async (deviceSerial: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceSerial' is not null or undefined
            assertParamExists('stopSqi', 'deviceSerial', deviceSerial)
            const localVarPath = `/eeg-quality/{deviceSerial}/stop`
                .replace(`{${"deviceSerial"}}`, encodeURIComponent(String(deviceSerial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EegQualityControllerApi - functional programming interface
 * @export
 */
export const EegQualityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EegQualityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSqiStatus(deviceSerial: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScanEegQualityTransmissionStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSqiStatus(deviceSerial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EegQualityControllerApi.getSqiStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startSqi(deviceSerial: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startSqi(deviceSerial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EegQualityControllerApi.startSqi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopSqi(deviceSerial: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopSqi(deviceSerial, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EegQualityControllerApi.stopSqi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EegQualityControllerApi - factory interface
 * @export
 */
export const EegQualityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EegQualityControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSqiStatus(deviceSerial: string, options?: any): AxiosPromise<ScanEegQualityTransmissionStatus> {
            return localVarFp.getSqiStatus(deviceSerial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSqi(deviceSerial: string, options?: any): AxiosPromise<void> {
            return localVarFp.startSqi(deviceSerial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} deviceSerial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopSqi(deviceSerial: string, options?: any): AxiosPromise<void> {
            return localVarFp.stopSqi(deviceSerial, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EegQualityControllerApi - object-oriented interface
 * @export
 * @class EegQualityControllerApi
 * @extends {BaseAPI}
 */
export class EegQualityControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} deviceSerial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EegQualityControllerApi
     */
    public getSqiStatus(deviceSerial: string, options?: RawAxiosRequestConfig) {
        return EegQualityControllerApiFp(this.configuration).getSqiStatus(deviceSerial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceSerial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EegQualityControllerApi
     */
    public startSqi(deviceSerial: string, options?: RawAxiosRequestConfig) {
        return EegQualityControllerApiFp(this.configuration).startSqi(deviceSerial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} deviceSerial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EegQualityControllerApi
     */
    public stopSqi(deviceSerial: string, options?: RawAxiosRequestConfig) {
        return EegQualityControllerApiFp(this.configuration).stopSqi(deviceSerial, options).then((request) => request(this.axios, this.basePath));
    }
}

